import React, { useEffect } from 'react';
import { LoadingOutlined } from '@ant-design/icons';

import { Layout } from 'shared/components/layout/Layout';
import { useLayoutState } from 'shared/components/layout/useLayoutState';
import { useUserCapabilities } from 'shared/hooks';
import { UserCapabilities } from 'utilities/const';
import {
  DashboardFooter,
  DashboardLayout,
  DashboardLoading,
  DashboardAppsNavigation,
  DashboardTitle,
} from './Dashboard.styles';
import { DashboardApp } from './DashboardApplicationItem';

export function Dashboard() {
  const { dispatch: dispatchLayout } = useLayoutState();
  const { capabilities, loadingCapabilities } = useUserCapabilities();
  const year = new Date().getFullYear();

  useEffect(() => {
    dispatchLayout({ type: 'SET_BREADCRUMBS', breadcrumbs: [] });
  }, []);

  return (
    <DashboardLayout>
      <Layout>
        <DashboardTitle>Welcome back, here are your available apps</DashboardTitle>
        {loadingCapabilities ? (
          <DashboardLoading>
            <LoadingOutlined />
          </DashboardLoading>
        ) : (
          <DashboardAppsNavigation>
            {capabilities.includes(UserCapabilities.UseLeashApp) && (
              <DashboardApp appName="Leash" legend="Travel planning" />
            )}
            {capabilities.includes(UserCapabilities.UsePricingApp) && (
              <DashboardApp appName="Pricing" legend="Contracts & Commitments" />
            )}
            {capabilities.includes(UserCapabilities.UsePupDocsApp) && (
              <DashboardApp appName="PupDocs" legend="Document management" />
            )}
            {capabilities.includes(UserCapabilities.UseDogParkApp) && (
              <DashboardApp appName="DogPark" legend="Breeder account management" />
            )}
          </DashboardAppsNavigation>
        )}
      </Layout>
      <DashboardFooter>© {year} PuppySpot - All rights reserved</DashboardFooter>
    </DashboardLayout>
  );
}
